








import { Component } from "vue-property-decorator";
import OverviewMixin from "@/mixins/admin/overviewMixin";

@Component({
  components: {
    "credit-notes-table": () =>
      import("@/components/app/global/creditNotes/creditNotesTable.vue")
  }
})
export default class AdminCreditNotesOverview extends OverviewMixin {
  // Override OverviewMixin
  public get tableId() {
    return "CNT1";
  }
  // Override OverviewMixin
  public get defaultLabel(): string {
    return this.$t("_.credit_notes") as string;
  }
}
